<div class="privacy-policy">
  <div class="bg-image">
    <img src="assets/images/sigin.webp" alt="Background">
  </div>

  <nav class="navbar">
    <img src="assets/images/logo-light.svg" alt="Logo">
    <a routerLink="/auth/login">
      <i class="las la-arrow-left"></i>
      {{ 'USERS.SIGNIN' | translate }}
    </a>
  </nav>

  <div class="content-wrapper">
    <!-- DE -->
    <article class="content" *ngIf="translateService.currentLang === 'de'; else enBlock">
      <h2 class="text-center">{{ 'TERMS.TITLE' | translate }}</h2>
      <p class="text-center mb-4">Gültig ab: {{ effectiveDate }}</p>

      <h3>1. Annahme der Bedingungen</h3>
      <p>Durch die Registrierung oder Nutzung unserer Plattform erklären Sie sich mit diesen Nutzungsbedingungen und unserer Datenschutzerklärung einverstanden.</p>

      <h3>2. Angebotene Dienste</h3>
      <ul>
        <li>Verwaltung von Immobilienvermietungen</li>
        <li>Erstellung von Versorgungsabrechnungen</li>
        <li>Sichere Online-Zahlungen über FinAPI</li>
      </ul>

      <h3>3. Benutzerkonten</h3>
      <p>Sie müssen genaue Angaben machen und Ihr Konto sichern. Sie sind für alle Aktivitäten unter Ihrem Konto verantwortlich.</p>

      <h3>4. Zahlungsdienste</h3>
      <p>Zahlungen werden über FinAPI GmbH abgewickelt. Bei Nutzung der Zahlungsfunktion akzeptieren Sie die Bedingungen von FinAPI.</p>
      <p>Wir speichern keine Bankzugangsdaten. Alle Zahlungsfreigaben erfolgen über die Standalone-Oberfläche von FinAPI.</p>

      <h3>5. Pflichten des Nutzers</h3>
      <ul>
        <li>Die Plattform rechtmäßig nutzen</li>
        <li>Zahlungsfunktionen nicht missbrauchen</li>
        <li>Andere Nutzer und Eigentümer respektieren</li>
      </ul>

      <h3>6. Haftungsbeschränkung</h3>
      <ul>
        <li>Bankangelegenheiten außerhalb unserer Kontrolle</li>
        <li>Datenverstöße außerhalb unserer Infrastruktur</li>
        <li>Fehler von Drittanbietern (z. B. FinAPI, Banken)</li>
      </ul>

      <h3>7. Kündigung</h3>
      <p>Wir können den Zugang bei Verstößen, gesetzlichen Anforderungen oder Missbrauch sperren oder beenden.</p>

      <h3>8. Geltendes Recht</h3>
      <p>Es gilt das Recht von [Ihre Gerichtsbarkeit]. Streitigkeiten werden vor Gerichten in [Stadt, Land] beigelegt.</p>

      <h3>9. Kontakt</h3>
      <address>
        Insight360 GmbH
        Bernhard-Otte-Straße 12 46395 Bocholt
        E-Mail: info&#64;insight360.tech
      </address>
    </article>

    <!-- EN -->
    <ng-template #enBlock>
      <article class="content">
        <h2 class="text-center">{{ 'TERMS.TITLE' | translate }}</h2>
        <p class="text-center mb-4">Effective Date: {{ effectiveDate }}</p>

        <h3>1. Acceptance of Terms</h3>
        <p>By registering or using our platform, you agree to be bound by these Terms of Use and our Privacy Policy.</p>

        <h3>2. Services Provided</h3>
        <ul>
          <li>Managing property rentals</li>
          <li>Issuing utility bills</li>
          <li>Secure online payments via FinAPI</li>
        </ul>

        <h3>3. User Accounts</h3>
        <p>You must provide accurate information and keep your account secure. You are responsible for all activities under your account.</p>

        <h3>4. Payment Services</h3>
        <p>Payments are processed through FinAPI GmbH. When using payment functionality, you agree to FinAPI’s terms.</p>
        <p>We do not store your banking credentials. All payment authorizations are handled via FinAPI’s Standalone UI.</p>

        <h3>5. User Obligations</h3>
        <ul>
          <li>Use the platform lawfully</li>
          <li>Do not misuse payment features</li>
          <li>Respect other users and property owners</li>
        </ul>

        <h3>6. Limitation of Liability</h3>
        <ul>
          <li>Bank-related issues outside our control</li>
          <li>Data breaches beyond our infrastructure</li>
          <li>Errors caused by third-party providers (e.g., FinAPI, banks)</li>
        </ul>

        <h3>7. Termination</h3>
        <p>We may suspend or terminate your access for violations of these terms, legal requests, or misuse.</p>

        <h3>8. Governing Law</h3>
        <p>These terms are governed by the laws of [Your Jurisdiction]. Disputes will be resolved in courts located in [City, Country].</p>

        <h3>9. Contact</h3>
        <address>
          Insight360 GmbH
          Bernhard-Otte-Straße 12 46395 Bocholt
          E-Mail: info&#64;insight360.tech
        </address>
      </article>
    </ng-template>
  </div>
</div>
